import { publicApi } from './index';

export const login = (credentials: { dni: string; password: string }) =>
  publicApi.post('/authentication/signin', credentials);
